const equipmentList = {
  area: "Area",
  "v-card-title": "Assets",
  plantList: "Areas",
  "span-statitics": "Graphs",
  "span-inspections-list": "Check Equipment Inspections",
  "span-repair-list": "Check Repair Log",
  "span-new-repair-logs": "New Repair Report",
  "belongs-to": "Belongs To",
  customer: "Company",
  equipImg: "Equipment Image",
  equipTag: "Equipment Tag",
  status: "Reliability Status",
  equipType: "Equipment Type",
  inspections: "New Inspection",
  "label-search": "Search",
  operations: "Status from Operations",
  plant: "Plant",
  profile: "Profile",
  pilot: "DEV",
  cancel: "Cancel",
  reliability: "New Reliability Report",
  "repair-logs": "New Reparation",
  unit: "Unit",
  scanAndInspect: "Scan And Inspect",
  reportError: "Tech Support",
  scanQR: "Scan QR",
  zones: {
    zone: "Zone",
    smooth: "Smooth",
    warning: "Warning",
    alarm: "Alarm"
  },
  running: "Running"
};

export default equipmentList;
